import { Box, useTheme } from "@mui/material";
import type { FC } from "react";
import { ReminderDateCalendar } from "web_myplann/Shared/Components/ReminderDateCalendar";

type Props = {
	value: Date | null;
	minDate: Date;
	onSelect: (date: Date) => void;
};

export const ReminderSnoozeCustomDate: FC<Props> = ({
	value,
	minDate,
	onSelect,
}) => {
	const { palette, spacingTokens, colors } = useTheme();

	return (
		<Box
			mx={-spacingTokens.xl}
			bgcolor={palette.background.paper}
			borderTop={colors.border.solid(palette.surface.border)}
		>
			<ReminderDateCalendar
				value={value}
				minDate={minDate}
				onSelect={onSelect}
			/>
		</Box>
	);
};
